const defaultState = {
  name: '',
};

export default function userReducer(state = defaultState, action) {
  switch (action.type) {
    case 'SET_USER': {
      return { ...state, ...action.payload };
    }
    case 'SET_LAST_AUTH':
      return { ...state, last_login: action.payload };
    default: {
      return state;
    }
  }
}